"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("../../../utils/styles");

var _ref2 = /*#__PURE__*/_react.default.createElement("path", {
  d: "M4.89 9.01h8.136",
  stroke: "#FFF",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var IndeterminateIcon = /*#__PURE__*/_react.default.memo(function (_ref) {
  var color = _ref.color,
      props = (0, _objectWithoutProperties2.default)(_ref, ["color"]);
  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "18",
    height: "18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: color || theme.colors.secondary,
    x: "2",
    y: "2",
    width: "14",
    height: "14",
    rx: "3"
  }), _ref2));
});

var _default = IndeterminateIcon;
exports.default = _default;